import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useNotifications } from "@/contexts/NotificationContext";
import { useAuth } from "@/contexts/UnifiedAuthContext";
import { useNavigate } from "react-router-dom";

export const useDeleteRecord = () => {
  const queryClient = useQueryClient();
  const { addNotification } = useNotifications();
  const { user } = useAuth();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (recordId: string) => {
      if (!user) {
        throw new Error("Пользователь не авторизован");
      }
      
      const { data, error } = await supabase
        .from('records')
        .update({ deleted_at: new Date().toISOString() })
        .eq('id', recordId)
        .eq('user_id', user.id)
        .select();
        
      if (error) {
        throw error;
      }
      return data;
    },
    onSuccess: (_, recordId) => {
      // Инвалидируем кэш для обновления списка записей
      queryClient.invalidateQueries({ queryKey: ['records'] });
      
      // Также инвалидируем кэш для конкретной записи
      queryClient.invalidateQueries({ queryKey: ['record', recordId] });
      
      addNotification({
        userId: user?.id || "unknown",
        type: "success",
        message: "Запись успешно удалена"
      });
      
      // Перенаправляем пользователя на страницу "Мои записи"
      navigate("/dashboard", { replace: true });
    },
    onError: (error) => {
      console.error('Ошибка при удалении записи:', error);
      addNotification({
        userId: user?.id || "unknown",
        type: "error",
        message: "Ошибка при удалении записи"
      });
    }
  });
};


